<template>
  <div>
    <highcharts :options="chartOptions"></highcharts>
    <p><small>Dödsfallen visas enligt dödsdag och rapporteras med upp till tre månaders fördröjning.</small></p>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import dataModule from 'highcharts/modules/data'
dataModule(Highcharts)

export default {
  name: 'DeathsChart',
  components: {
  },
  props: {
    showShort: Boolean,
  },
  data() {
    return {
      series: null,
    }
  },
  computed: {
    updated() {
      if (this.series) {
        const lastIndex = this.series[1].data.length - 1;
        const time = new Date(this.series[1].data[lastIndex][0]);
        const date = `${time.getDate()}.${time.getMonth() + 1}.${time.getFullYear()}`;
        return `Uppdaterad ${date}`;
      }
      return null;
    },
    chartOptions() {
      const today = new Date();
      return {
        chart: {
          height: 250,
          type: 'column',
          spacing: [12, 2, 2, 2],
          backgroundColor: 'transparent',
        },
        colors: ['#888'],
        data: {
          csvURL: (process.env.NODE_ENV === 'production' ? 'https://svenska-dataviz.ylestatic.fi/2020-03-corona/' : 'http://local.yle.fi:8080/data/') + 'finland-deaths.csv',
          itemDelimiter: ',',
          lineDelimiter: '\n',
          complete: (options) => {
            this.series = options.series;
            options.series[1] = {
              name: '7 dagars medeltal',
              data: options.series[1].data,
              type: 'line',
              color: '#222',
              enableMouseTracking: true,
              tooltip: {
                pointFormatter: function() {
                  return '<span style="color:' + this.color + '">●</span> ' + this.series.name + ': <b>' + Highcharts.numberFormat(this.y,1,",") + '</b><br/>'
                }
              },
            };
          },
        },
        title: false,
        subtitle: false,
        credits: {
          enabled: false,
        },
        legend: {
          floating: true,
          align: 'left',
          verticalAlign: 'top',
          x: 40,
          symbolRadius: 0,
          itemStyle: {
            fontWeight: 'normal',
          },
        },
        xAxis: {
          type: 'datetime',
          tickmarkPlacement: 'on',
          crosshair: true,
          title: {
            enabled: false,
          },
          min: this.showShort ? new Date().setDate(today.getDate()-31) : Date.UTC(2020, 2, 25),
        },
        yAxis: {
          title: false,
          labels: {
            align: 'left',
            x: 0,
            y: -3,
          },
          min: 0,
        },
        tooltip: {shared: true},
        plotOptions: {
          series: {
            lineWidth: 3,
            pointPadding: this.showShort ? 0.1 : 0,
            groupPadding: this.showShort ? 0.1 : 0,
          },
          column: {
            stacking: 'normal',
          },
        },
      }
    }
  },
}
</script>
